module.exports = __webpack_public_path__ + "static/media/Doctor on demand uses Curoflow telemedicine platform.86a6d896.webp";